export const PINNED_PREVIEW_MAX_CHARS = 80;

export const PINNED_STRIP_HEADER_LABEL = 'Pinned messages';

export const PINNED_STRIP_UNPIN_TOOLTIP = 'Unpin message';

export const PINNED_STRIP_EXPAND_TOOLTIP = 'Show all pinned messages';

export const PINNED_STRIP_COLLAPSE_TOOLTIP = 'Collapse';

export const PINNED_STRIP_COLLAPSE_THRESHOLD = 2;
